import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperRestoreStore from "./DataMapperRestoreStore";

const restoreStore = (rootStore: RootStore) =>
  rootStore.dataMapperRestoreViewStore as DataMapperRestoreStore;

/**
 * Data Mapper → Restore (ADMIN): restore a SQL Server .BAK under a new name.
 * `requiresAdmin` hides it from operators in the nav and page search; the store
 * calls nothing for a non-admin, and the API (data-mapper-restore) refuses
 * anyone else with 403, which the page also handles.
 */
const dataMapperRestoreRoute: RouteType[] = [
  {
    name: "Data Mapper Restore",
    path: "/data-mapper/restore",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Restore Backup",
        enableRefreshButton: true,
        component: () => import("./DataMapperRestore.Header"),
      },
      body: {
        component: () => import("./DataMapperRestore.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["restore bak", "sql backup restore", "data mapper restore"],
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void restoreStore(rootStore)?.enter();
    },
    onExit: ({ rootStore }) => {
      restoreStore(rootStore)?.reset();
    },
  },
];

export default dataMapperRestoreRoute;
